module.exports = __webpack_public_path__ + "media/images/vp/icon.people-d4646edec41704e7e92e474e2813ca88.svg";